"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _Theme = require("../../Theme");

var _Button = require("./v2/Button");

var _Button2 = require("./v3/Button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** A button with various size and color settings */
var Button = /*#__PURE__*/_react.default.forwardRef(function (props, forwardedRef) {
  var Component = (0, _Theme.useThemeConfig)({
    v2: _Button.ButtonV2,
    v3: _Button2.ButtonV3
  });
  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    ref: forwardedRef
  }, props));
});

exports.Button = Button;
Button.displayName = "Button";
Button.defaultProps = {
  size: "medium",
  variant: "primaryBlack"
};
//# sourceMappingURL=Button.js.map